import { gql } from '../../../../../types/__codegen__/sanity';

export const GET_EXPLAINED_TERM = gql(`
  query getExplainedTerm($slug: String) {
    allExplainedTerm(where: { identifier: { current: { eq: $slug } } }) {
      ...ExplainedTermFields
      insuranceType {
        identifier {
          current
        }
      }
      metadataObject {
        name
        descriptionRaw
      }
      refersToContent {
        ... on ProductList {
          ...ProductListFields
        }
        ... on Award {
          ...AwardFields
        }
        ... on HowTo {
          ...HowToFields
        }
        ... on ValuePropositionsObject {
          title
          valuePropositionsReference {
            ...ValuePropositionFields
          }
          urlObject {
            ...UrlObjectFields
          }
        }
        ... on CommonQuestions {
          ...CommonQuestionsFields
        }
        ... on RelatedTopicsUrl {
          urlObjects {
            ...UrlObjectFields
          }
        }
        ... on SellingPointGroup {
          ...SellingPointFields
        }
        ... on TopicGroup {
          ...TopicGroupFields
        }
        ... on ContentTiles {
          tiles {
            ... on Service {
              ...ContentTileFields
              imageObject {
                ...ImageObjectFields
              }
            }
          }
        }
        ... on ExternalContent {
          __typename
          identifier {
            current
          }
          title
        }
      }
    }
  }
`);
